import { when } from '@execonline-inc/maybe-adapter';
import { observer } from 'mobx-react';
import * as React from 'react';
import { T } from '../../../../../../../../Translations';
import ChevronDown from '../../../../../../../Cutesies/ChevronDown';
import ProductTypeFilterStore from './Store';

interface Props {
  productTypeFilterStore: ProductTypeFilterStore;
}

const selectedProductTypeValuesLength = (productTypeFilterStore: ProductTypeFilterStore) =>
  productTypeFilterStore.state.filter.productTypes.length;

const whenNotAllProductTypesSelected = (productTypeFilterStore: ProductTypeFilterStore) =>
  when(
    selectedProductTypeValuesLength(productTypeFilterStore) <
      productTypeFilterStore.initialFilterValues.productTypes.length,
    {},
  );

const FilterButtonText: React.FC<Props> = ({ productTypeFilterStore }) =>
  whenNotAllProductTypesSelected(productTypeFilterStore)
    .map(() => (
      <div className="flex flex-row justify-between w-full">
        <T
          kind="Selected: ({{count}})"
          count={selectedProductTypeValuesLength(productTypeFilterStore)}
        />
        <div className="w-5">
          <ChevronDown />
        </div>
      </div>
    ))
    .getOrElse(() => (
      <div className="flex flex-row justify-between w-full">
        <T kind={'Program Type'} />
        <div className="w-5">
          <ChevronDown />
        </div>
      </div>
    ));

export default observer(FilterButtonText);
